import { takeEvery, take, put } from 'redux-saga/effects';
import { actions as updateDocsActions } from './get-user-documents';
import { consts as deleteDocsConsts } from './delete-user-documents';
import { consts as updateDocsConsts } from './update-user-documents';
import { consts as uploadDocsConsts } from './upload-user-documents';

function* updateDocumentsWorker(action) {
  const { type, payload } = action;
  const { id } = payload;
  if (type === deleteDocsConsts.SEND) {
    yield take(deleteDocsConsts.SUCCEED);
    yield put(updateDocsActions.deleteItem({ id }));
  } else {
    yield put(updateDocsActions.updateList(payload));
  }
}

export function* updateDocumentsSaga() {
  yield takeEvery(
    [uploadDocsConsts.SUCCEED, updateDocsConsts.SUCCEED, deleteDocsConsts.SEND],
    updateDocumentsWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/profiles/updateDocumentsSaga.js